export const splitArrayIntoChunks = (arr: Array<any> = [], chunkSize: number): Array<Array<any>> => {
    const clone = [...arr];
    const result = [];
    while (clone?.length > 0) {
        result.push(clone?.splice(0, chunkSize));
    }
    return result;
};
